module.exports = __webpack_public_path__ + "img/8campus-20diplomes.fcdd9ad.jpg";